import { useContext } from 'react'
import { AppContext } from './AppContext'

export function useApp() {
  const context = useContext(AppContext)

  if (!context) {
    throw new Error('useApp must be used within an AppContextProvider')
  }

  return context
}
